import { makeStyles } from 'tss-react/mui';

export const useFormStyles = makeStyles()(theme => ({
  formControl: {
    marginBottom: theme.spacing(3)
  },
  formGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    maxWidth: '400px'
  },
  columnFlex: {
    display: 'flex',
    flexDirection: 'column',
  },
  width400: {
    maxWidth: '400px',
  },
  width120: {
    maxWidth: '120px'
  },
  width140: {
    maxWidth: '140px'
  },
  addButton: {
    // marginTop: -theme.spacing(3) + 10,
    marginBottom: 10,
    '& > button': {
      textAlign: 'left',
      paddingTop: '12px',
      paddingBottom: '12px',
    }
  },
  creditCards: {
    margin: 0,
    display: 'flex',
    gap: theme.spacing(1),
    flexWrap: 'wrap',
    justifyContent: 'flex-end',
    '& > *': {
      margin: '0 !important'
    }
  },
  middleNameButton: {
    textTransform: 'none',
    width: '242px'
  }
}));
